export interface IFile {
  filePath: string;
  fileName: string;
  fileExt?: FileExt;
}

export enum FileExt {
  doc = 'doc',
  docx = 'docx',
  xls = 'xls',
  xlsx = 'xlsx',
  pdf = 'pdf',
  zip = 'zip',
  rar = 'rar',
  md = 'md',
  jpeg = 'jpeg',
  jpg = 'jpg',
  png = 'png',
  gif = 'gif',
  tiff = 'tiff',
  eps = 'eps',
  svg = 'svg',
  csv = 'csv'
}

export function isFileExt(u: unknown): u is FileExt {
  return typeof u === 'string' && Object.values(FileExt).some(v => v === u);
}
